module.exports = __webpack_public_path__ + "fontawesome-webfont.f7c2b4b747b1a225eb8d.eot";


//////////////////
// WEBPACK FOOTER
// /usr/local/app/src/assets/font-awesome/fonts/fontawesome-webfont.eot?v=4.3.0
// module id = ../../../../../src/assets/font-awesome/fonts/fontawesome-webfont.eot?v=4.3.0
// module chunks = 2